exports.initializePersonaPage = function() {
    // --- ELEMENT SELECTORS ---
    const startButton = document.getElementById('start-button');
    if (!startButton) return; // Exit if not on the right page

    const mainContent = document.getElementById('main-content');
    const facetsContainer = document.getElementById('facets-container');
    const generatePromptButton = document.getElementById('generate-prompt-button');
    const resultsContainer = document.getElementById('results');
    const systemPromptTextarea = document.getElementById('system-prompt');
    const savePromptButton = document.getElementById('save-prompt-button');
    const savedPromptsList = document.getElementById('prompt-list');
    const savePromptModalEl = document.getElementById('savePromptModal');
    const savePromptModal = new bootstrap.Modal(savePromptModalEl);
    const savePromptForm = document.getElementById('save-prompt-form');
    const promptNameInput = document.getElementById('prompt-name');
    const promptDescriptionInput = document.getElementById('prompt-description');

    // --- STATE ---
    let loadedFacets = [];

    // --- HELPERS ---

    function getResourceId(resource) {
        if (!resource) return null;
        if (typeof resource._id === 'object' && resource._id !== null && resource._id.$oid) {
            return resource._id.$oid;
        }
        return resource.id || resource._id || resource._key;
    }

    // --- CORE FUNCTIONS ---

    async function loadFacetsAndRender() {
        try {
            const response = await axios.get('/api/facets');
            loadedFacets = response.data;
            const groupedFacets = loadedFacets.reduce((acc, facet) => {
                const dim = facet.dimension;
                const subDim = facet.sub_dimension;
                if (!acc[dim]) acc[dim] = {};
                if (!acc[dim][subDim]) acc[dim][subDim] = [];
                acc[dim][subDim].push(facet);
                return acc;
            }, {});
            renderFacetAccordion(groupedFacets);
        } catch (error) {
            console.error('Error loading facets:', error);
            facetsContainer.innerHTML = '<div class="alert alert-danger">Error loading personality facets.</div>';
        }
    }

    function renderFacetAccordion(groupedFacets) {
        let accordionId = 'facet-accordion';
        let html = `<div class="accordion" id="${accordionId}">`;
        let dimensionIndex = 0;
        for (const dimension in groupedFacets) {
            const dimensionId = `dim-${dimensionIndex}`;
            html += `
                <div class="card">
                    <div class="card-header" id="header-${dimensionId}">
                        <h2 class="mb-0">
                            <button class="btn btn-link btn-block text-left" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${dimensionId}" aria-expanded="true" aria-controls="collapse-${dimensionId}">
                                ${dimension}
                            </button>
                        </h2>
                    </div>
                    <div id="collapse-${dimensionId}" class="collapse ${dimensionIndex === 0 ? 'show' : ''}" aria-labelledby="header-${dimensionId}" data-bs-parent="#${accordionId}">
                        <div class="card-body">`;
            for (const subDimension in groupedFacets[dimension]) {
                html += `<h5>${subDimension}</h5>`;
                groupedFacets[dimension][subDimension].forEach(facet => {
                    const facetId = getResourceId(facet);
                    html += `
                        <div class="form-check">
                            <input class="form-check-input facet-checkbox" type="checkbox" value="${facet.promptCharacteristic}" id="facet-${facetId}">
                            <label class="form-check-label" for="facet-${facetId}">
                                ${facet.promptCharacteristic}
                            </label>
                        </div>`;
                });
                html += '<hr>';
            }
            html += `   </div>
                    </div>
                </div>`;
            dimensionIndex++;
        }
        html += '</div>';
        facetsContainer.innerHTML = html;
    }

    function generatePromptText() {
        const selectedCheckboxes = facetsContainer.querySelectorAll('.facet-checkbox:checked');
        if (selectedCheckboxes.length === 0) {
            alert('Please select at least one characteristic.');
            return;
        }
        let prompt = "You are an AI assistant. Your personality is defined as follows:\n\n";
        selectedCheckboxes.forEach(checkbox => {
            prompt += `- ${checkbox.value}\n`;
        });
        systemPromptTextarea.value = prompt;
        resultsContainer.style.display = 'block';
    }

    async function loadAndRenderSavedPrompts() {
        try {
            const response = await axios.get('/api/prompts');
            const prompts = response.data.filter(p => !p.is_standard);
            savedPromptsList.innerHTML = '';
            if (prompts.length === 0) {
                savedPromptsList.innerHTML = '<li class="list-group-item">You have no saved personas yet.</li>';
                return;
            }
            prompts.forEach(prompt => {
                const promptId = getResourceId(prompt);
                const li = document.createElement('li');
                li.className = 'list-group-item d-flex justify-content-between align-items-center';
                li.dataset.id = promptId;
                li.dataset.name = prompt.name;
                li.dataset.description = prompt.description || '';
                li.dataset.promptText = prompt.prompt_text;
                li.innerHTML = renderPromptView(prompt);
                savedPromptsList.appendChild(li);
            });
        } catch (error) {
            console.error('Error loading saved prompts:', error);
            savedPromptsList.innerHTML = '<li class="list-group-item text-danger">Error loading saved personas.</li>';
        }
    }

    function renderPromptView(prompt) {
        return `
            <div>
                <h6 class="my-0">${prompt.name}</h6>
                <small class="text-muted">${prompt.description || ''}</small>
            </div>
            <div>
                <button class="btn btn-sm btn-outline-secondary edit-prompt-btn">Edit</button>
                <button class="btn btn-sm btn-outline-danger delete-prompt-btn">Delete</button>
            </div>
        `;
    }

    async function handlePromptListClick(event) {
        const target = event.target;
        const li = target.closest('li.list-group-item');
        if (!li) return;

        const promptId = li.dataset.id;

        if (target.classList.contains('delete-prompt-btn')) {
            if (!confirm('Are you sure you want to delete this persona?')) return;
            try {
                await axios.delete(`/api/prompts/${promptId}`);
                loadAndRenderSavedPrompts();
            } catch (error) {
                console.error('Error deleting prompt:', error);
                alert('Error deleting persona.');
            }
        } else if (target.classList.contains('edit-prompt-btn')) {
            const promptName = li.dataset.name;
            const promptDescription = li.dataset.description;
            const promptText = li.dataset.promptText;

            promptNameInput.value = promptName;
            promptDescriptionInput.value = promptDescription;
            systemPromptTextarea.value = promptText;
            resultsContainer.style.display = 'block'; // Show the results container with the prompt text

            // Store the promptId in a data attribute on the form for later use during save
            savePromptForm.dataset.editingPromptId = promptId;
            savePromptModal.show();
        }
    }

    async function handleSavePromptForm(event) {
        event.preventDefault();
        const name = promptNameInput.value.trim();
        const description = promptDescriptionInput.value.trim();
        const promptText = systemPromptTextarea.value;
        const editingPromptId = savePromptForm.dataset.editingPromptId; // Get the ID if editing

        if (!name || !promptText) {
            alert('Please provide a name for the persona.');
            return;
        }

        try {
            if (editingPromptId) {
                // Update existing prompt
                await axios.put(`/api/prompts/${editingPromptId}`, {
                    name: name,
                    description: description,
                    prompt_text: promptText
                });
            } else {
                // Create new prompt
                await axios.post('/api/prompts', {
                    name: name,
                    description: description,
                    prompt_text: promptText
                });
            }
            savePromptModal.hide();
            loadAndRenderSavedPrompts();
            promptNameInput.value = '';
            promptDescriptionInput.value = '';
            systemPromptTextarea.value = '';
            resultsContainer.style.display = 'none';
            facetsContainer.querySelectorAll('.facet-checkbox:checked').forEach(cb => cb.checked = false);
            delete savePromptForm.dataset.editingPromptId; // Clear editing state
        } catch (error) {
            console.error('Error saving prompt:', error);
            alert('Error saving persona.');
        }
    }
    
    // --- EVENT LISTENERS ---
    startButton.addEventListener('click', function () {
        mainContent.style.display = 'block';
        startButton.style.display = 'none';
        loadFacetsAndRender();
    });
    
    if (generatePromptButton) {
        generatePromptButton.addEventListener('click', generatePromptText);
    }
    if (savePromptButton) {
        savePromptButton.addEventListener('click', () => {
            // When saving a new prompt, ensure no editing ID is set
            delete savePromptForm.dataset.editingPromptId;
            savePromptModal.show();
        });
    }
    if (savePromptForm) {
        savePromptForm.addEventListener('submit', handleSavePromptForm);
    }
    if (savedPromptsList) {
        savedPromptsList.addEventListener('click', handlePromptListClick);
    }

    // --- INITIALIZATION ---
    if(savedPromptsList) {
        loadAndRenderSavedPrompts();
    }
};